import React  from "react";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";
import PropTypes from "prop-types";

import SelectBodyTypeRadioButton from "./SelectBodyTypeRadioButton";
import DropDownVariantIconButton from "../DropDown/DropDownVariantIconButton";

import { getOptionKey } from "../../utils/select";
import { translateObjectsArray } from "../../utils/multilang/i18n";

const TRANSLATE_OPTIONS = {
  translateOptions: {
    nsSeparator: false,
  }
};

const SelectVariantIconButton = ({
  isHideOnSelect = true,
  icon,
  disabled,
  active,
  iconTitle,
  className,
  dropDownClassName,
  options,
  value,
  labels,
  slotsAfterOptions,
  onChange,
  withRadio = false,
  toggleOnMouseOverLeave,
  id,
  style,
  popupProps,
}) => {
  const isValueArray = Array.isArray(value);
  const isMoreThanOneSetOfOptions = !!(options?.[0] && options.some((o) => Array.isArray(o)));
  const isDisabled = !options.length;

  const { t } = useSharedTranslation();

  const handleChange = (valueNew, indexOptionNew, indexGroupOptionNew) => {
    if (onChange && valueNew) {
      const valueNewNormalized = (Array.isArray(valueNew) ? valueNew : [valueNew])
        .map((option) => getOptionKey(option));
      // if value was an array then return as an array of keys.
      // if value was a primitive then return as a primitive key.
      onChange(
        isValueArray ? valueNewNormalized : valueNewNormalized[0],
        indexOptionNew,
        indexGroupOptionNew,
      );
    }
  };

  return (
    <DropDownVariantIconButton
      disabled={disabled || isDisabled}
      iconTitle={iconTitle}
      icon={icon}
      className={className}
      active={active}
      toggleOnMouseOverLeave={toggleOnMouseOverLeave}
      id={id}
      style={style}
      popupProps={popupProps}
    >
      {
        ({hide}) => (
          <SelectBodyTypeRadioButton
            className={dropDownClassName}
            withRadio={withRadio}
            value={value}
            slotsAfterOptions={slotsAfterOptions}
            labels={labels}
            options={isMoreThanOneSetOfOptions
              ? options.map((o) => translateObjectsArray(o, t, TRANSLATE_OPTIONS))
              : translateObjectsArray(options, t, TRANSLATE_OPTIONS)}
            onSelect={(valueNew, indexOptionNew, indexGroupOptionNew, e) => {
              handleChange(valueNew, indexOptionNew, indexGroupOptionNew);

              if (isHideOnSelect) {
                hide(e);
              }
            }}
          />
        )
      }
    </DropDownVariantIconButton>
  );
};

SelectVariantIconButton.defaultProps = {
  withToggleDelayRestriction: true,
};

SelectVariantIconButton.propTypes = {
  isHideOnSelect: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.number]),
  iconTitle: PropTypes.string,
  dropDownClassName: PropTypes.string,
  className: PropTypes.string,
  options: PropTypes.array,
  labels: PropTypes.array,
  value: PropTypes.oneOfType([
    PropTypes.object, PropTypes.array, PropTypes.string, PropTypes.number
  ]),
  onChange: PropTypes.func,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  maxHeight: PropTypes.number,
  withRadio: PropTypes.bool,
  toggleOnMouseOverLeave: PropTypes.bool,
  id: PropTypes.string,
};

export default SelectVariantIconButton;
